module.exports = "/fonts/halona-logotype-d-d6f09f1551ef7174528b5674b075b451.svg";